export default __webpack_public_path__ + "static/media/SwapIcon.f3001461.svg";